import {Component, inject, Input, OnChanges,} from '@angular/core';
import {SectionsContainer} from '../../core/definitions/sections-container';
import {LoggerService} from '../../core/logger.service';
import {MetaField} from '../../core/definitions/meta-field';
import {FieldParameters} from '../../core/definitions/field-parameters';
import {InlineViewService} from "../../core/inline-view.service";
import {DateToolsService} from "../../core/date-tools.service";

@Component({
    selector: 'app-section-panel',
    templateUrl: './section-panel.component.html',
    styleUrls: ['./section-panel.component.scss'],
    standalone: false
})
export class SectionPanelComponent implements OnChanges {
  // Injections
  private readonly inlineViewService: InlineViewService = inject(InlineViewService);
  private readonly logger: LoggerService = inject(LoggerService);
  public readonly dateTools: DateToolsService = inject(DateToolsService);

  @Input() sectionsContainer: SectionsContainer;
  @Input() sectionName: string;
  @Input() edit: boolean;
  @Input() styleClass: string;

  fieldParameterList: FieldParameters[] = [];

  ngOnChanges(): void {
    let fields: MetaField[];
    if (this.sectionsContainer) {
      for (const section of this.sectionsContainer.sections) {
        if (section.name === this.sectionName) {
          fields = section.fields.filter(field => {
            return !!field.title;
          }).sort((field1, field2) => {
            return Number(field1.order) - Number(field2.order);
          });
          break;
        }
      }
      if (fields) {
        this.fieldParameterList = fields.map(field => {
          this.inlineViewService.getInlineViewForField(this.sectionsContainer.rootObject, field).then(
            inlineViewItem => {
              field.$$inlineView = inlineViewItem;
            })
          return {
            sectionsContainer: this.sectionsContainer,
            field: field,
            rootObject: this.sectionsContainer.rootObject,
            grandParentObject: undefined,
            object: this.sectionsContainer.rootObject,
            edit: this.edit,
            index: undefined,
            parentIndex: undefined,
            prevObject: undefined,
            useMultipleSetter: undefined,
            canAddNew: undefined,
            canDelete: undefined
          } as FieldParameters;
        });
      } else {
        this.logger.warn(`Edit section named ${this.sectionName} not found!`);
      }
    }
  }

  protected readonly Date = Date;
}
